export const FLAG_BAGGAGE_CONFIGURATION_ACTIVITY =
  'FLAG_BAGGAGE_CONFIGURATION_ACTIVITY';
export const GET_BAGGAGE_CONFIGURATION = 'GET_BAGGAGE_CONFIGURATION';
export const CLEAR_BAGGAGE_CONFIGURATION = 'CLEAR_BAGGAGE_CONFIGURATION';
